module.exports = __webpack_public_path__ + "static/img/Tizzy-T.6354342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Tizzy-T.jpg
// module id = 8cXI
// module chunks = 1